import { TableDrawer } from "@components/TableDrawer/TableDrawer";
import { useQuery } from "@hooks/useQuery";
import { decodeHTML } from "@utils/CommonUtils";
import { drilldownData, ModuleConfig } from "@utils/drilldownData";
import { TableColumnsType, Typography } from "antd";
import { get as _get } from "lodash";
import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { DataTable } from "~/Components";
import { magpCMSApi } from "~/Services";
import { renderActionsColumn, renderDateColumn, renderPublishedColumn } from "~/Utils/TableRenderFunction";
import { ProcurementPlanningForProcessFlowChart, useProcurementPlanningProcessFlowChart } from "../Manual.hook";

export interface ProcurementPlanningProcessFlowChartProps {
  listId: string;
  toggleId: string;
}

export const ProcurementPlanningProcessFlowChart: React.FC<ProcurementPlanningProcessFlowChartProps> = ({
  listId,
  toggleId,
}) => {
  const query = useQuery();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const firstQueryTab = query.get("activeTab");
  const secondQueryTab = query.get("subActiveTab");
  const thirdQueryTab = query.get("thirdChildActiveTab");

  const [drawerVisible, setDrawerVisible] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState<ProcurementPlanningForProcessFlowChart[]>([]);

  const id = searchParams.get("id");

  const {
    data: drilldown,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchdata,
  } = useProcurementPlanningProcessFlowChart(selectedRowData?.id ?? null);

  useEffect(() => {
    if (selectedRowData?.id) {
      refetchdata();
    }
  }, [selectedRowData?.id]);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      const url = `/api/get-procurement-planning-process-flow-chart/all-fields?listId=${listId}&toggleId=${toggleId}`;
      try {
        const res = await magpCMSApi.get(url);
        if (res && res.data) {
          setData(res.data);
        }
      } catch (err) {
        setData([]);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (id && data.length > 0) {
      const selectedRecord = data.find((rec: ProcurementPlanningForProcessFlowChart) => rec.id === id);

      if (selectedRecord) {
        setSelectedRowData(selectedRecord);
      }
    }
  }, [id, data]);

  if (isLoading) {
    return <Typography.Text>Loading...</Typography.Text>;
  }

  // if (id && selectedRowData) {
  //   return <EditProcurementPlanningProcessFlowChart record={selectedRowData} />;
  // }

  const columns: TableColumnsType = [
    {
      title: "Id",
      dataIndex: "field_procurement_sequence_numbe",
      key: "field_procurement_sequence_numbe",
      width: 60,
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      render: (text) => decodeHTML(text),
    },
    {
      title: "Created At",
      dataIndex: "field_procure_flow_chart_created",
      key: "field_procure_flow_chart_created",
      render: renderDateColumn,
    },
    {
      title: "Updated At",
      dataIndex: "field_procure_flow_chart_updated",
      key: "field_procure_flow_chart_updated",
      render: renderDateColumn,
    },
    {
      title: "Published",
      dataIndex: "published",
      key: "published",
      width: 60,
      render: (value: string) => renderPublishedColumn(value),
    },
    {
      title: "Actions",
      key: "actions",
      render: (record: any) =>
        renderActionsColumn(record, setSelectedRowData, setDrawerVisible, (e: any) => {
          e.preventDefault();
          navigate(
            `/dedicated/magp/manual/procurementPlanning?activeTab=${firstQueryTab}&subActiveTab=${secondQueryTab}&thirdChildActiveTab=${thirdQueryTab}&fourthChildActiveTab=${firstQueryTab + `ProcessFlowChart`}&editId=${record.id}`,
            { state: { record } }
          );
        }),
    },
  ];

  return (
    <>
      <DataTable
        columns={columns}
        className="table-clickable"
        tableData={data}
        isLoading={isLoading}
        height={1000}
        exportFileName="CONTRACT"
        isPagination={false}
        multiSelect={false}
        hideExport={true}
        isServerSearchApi={false}
        searchPlaceholderText={"Search"}
        onClick={(record) => {
          setSelectedRowData(record);
        }}
      />
      <TableDrawer
        title={
          <Typography.Title
            level={4}
            className={"!mb-0"}
          >
            Detailed View
          </Typography.Title>
        }
        visible={drawerVisible}
        onClose={() => setDrawerVisible(false)}
        fields={drilldownData[_get(drilldown, "subModule", "procurementPlanningProcessFlowChart") as ModuleConfig]}
        data={drilldown?.[0]}
      />
    </>
  );
};
